// extracted by mini-css-extract-plugin
module.exports = {"title":"ServiceDistriRule_style_title__2A0mu","step":"ServiceDistriRule_style_step__2J54l","stepTitle":"ServiceDistriRule_style_stepTitle__3gKaU"};